import React, { useState, useEffect, useRef } from 'react'
import './HeroCarousel.css'
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const HeroCarousel = ({ items, tagline }) => {
    const [width, setWidth] = useState(window.innerWidth);
    const wrapperRef = useRef(null);

    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
      const el = wrapperRef.current;
      if (!el) return;
      const handleWheel = (e) => {
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        window.scrollBy(0, e.deltaY);
        e.preventDefault();
      };
      el.addEventListener('wheel', handleWheel, { passive: false });
      return () => el.removeEventListener('wheel', handleWheel);
    }, []);

  return (
    <div className="hero-carousel-wrapper" ref={wrapperRef}>
    <Carousel
      showArrows={true}
      showStatus={false}
      showIndicators={true}
      showThumbs={false}
      swipeable={false}
      autoPlay={true}
      infiniteLoop={true}
      interval={4000}
      animationHandler={'fade'}
      transitionTime={2000}
      stopOnHover={false}
    >
      {items.map((item, index) => {
        const style =
          width <= 550
            ? {
                backgroundImage: `url(${item.srcNarrow})`,
              }
            : {
                backgroundImage: `url(${item.src})`,
              };

        return (
          <div className='hero_container' key={index}>
            <div className='img_container' style={style} loading='eager'></div>
            <div className="img_carousel_title_container">
              <h1>{item.title}</h1>
              {tagline && <p className="hero_carousel_tagline">{tagline}</p>}
            </div>
          </div>
        );
      })}
    </Carousel>
    </div>
  );
}

export default HeroCarousel